import { createApp } from 'vue'

import LogViewer from './components/LogViewer.vue'
import ProjectStandingPage from './components/ProjectStandingPage.vue'

const logsViewerMount = document.querySelector('#logs-viewer')
if (logsViewerMount) {
  createApp(LogViewer).mount(logsViewerMount)
}

const projectStandingMount = document.querySelector('#project-standing')
if (projectStandingMount) {
  createApp(ProjectStandingPage).mount(projectStandingMount)
}
